import React, { MutableRefObject, useEffect, useRef } from 'react'
import { GridFluid } from '@styles/global/cssGrid'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import { colors } from '@styles/global/colors'
import { Sentinel } from '@styles/global/fonts'
import { ICourse } from '@et/types/Courses'
import { scrollPageTo } from '@utils/genUtils'
import { IGatsbyChildImageSharp } from '@et/types/Gatsby'
import ImgSmall from '@components/imageModules/v2/imgSmall'
import { IMAGELOADINGENUMS } from '@et/types/Enums'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'

interface IProps {
  iPadImg: {
    gatsbyImageData: IGatsbyImageData
  }
  imgAlt: string
  buttonCssClass: string
  content: {
    title: string
    subtitle: string
    desc: string
  }
  customScrollId?: string
}

function SelfPacedV4(props: ICourse & IProps) {
  const { onSale, customScrollId, iPadImg, buttonCssClass, content, imgAlt } = props
  const courseCardMini: MutableRefObject<null | HTMLElement> = useRef(null)
  const sellCardId = onSale ? 'mini-card' : 'checkout-card'
  useEffect(() => {
    const scrollTo = customScrollId ? customScrollId : sellCardId
    courseCardMini.current = document.getElementById(scrollTo)
  }, [])

  function buttonClick() {
    scrollPageTo(courseCardMini)
  }

  return (
    <Wrapper className='lfm2020-selfPaced lfm-cssGrid'>
      <h2 className='lfm2020-h1'>{content.title}</h2>
      <h3>{content.subtitle}</h3>
      <div className='lfm2020-selfPaced__content'>
        <div dangerouslySetInnerHTML={{ __html: content.desc }} />
        <button
          onClick={buttonClick}
          className={`lfm-btn-round shadow3_alt lets-do-this ${buttonCssClass}`}>
          Enroll Now
        </button>
        <div className='lfm2020-selfPaced__texture'>
          <GatsbyImage alt={imgAlt} image={iPadImg.gatsbyImageData} loading={IMAGELOADINGENUMS.LAZY} />
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled(GridFluid)`
  text-align: center;
  grid-row-gap: 0 !important;
  position: relative;

  .lfm2020-h1 {
    grid-column: 2 /4;
    position: relative;
    z-index: 2;
    color: ${props => props.theme.headlineColor};
    
    @media ${device.tablet} {
      grid-column: 2 /14;
    }
    	
    @media ${device.laptop} {
      margin-bottom: 15px;
    }
  }

  h3 {
    color: ${props => props.theme.subheaderColor};
    grid-column: 2/4;
    -webkit-font-smoothing: auto;
    font-weight: 200;
    margin: 0;
    position: relative;
    z-index: 2;
    font-size: 24px;
    ${Sentinel.semiboldItalic};
    
    @media ${device.tablet} {
      grid-column: 3 /13;
      margin: 0 auto 30px;
      max-width: 500px;
    }
    @media ${device.laptop} {
      font-size: 38px;
      line-height: 1.2;
      margin: 0 auto 60px;
      grid-column: 2/14;
      max-width: 850px;
    }

  }
  
  .lfm2020-selfPaced__content {
    grid-column: 2/4;
    display: flex;
    flex-direction: column;
    z-index: 1;
    position: relative;

    p {
      font-size: 18px;
      position: relative;
      z-index: 2;

      &:nth-child(2) {
        font-style: italic;
      }

      &:nth-child(3) {
        margin-bottom: 30px;
      }
    }
    button {
      position: relative;
      z-index: 2;
    }

    @media ${device.tablet} {
      grid-column: 3/10;
      text-align: left;
      margin-left: -30px;
      margin-right: 40px;
      p {
        &:nth-child(1) {
          font-size: 21px;
        }
      }
      button {
        max-width: 200px;
      }
    }
    @media ${device.laptop} {
      grid-column: 3/9;
    }
  }
  .lfm2020-selfPaced__texture {
    display: none;
    @media ${device.tablet}  {
      display: block;
      position: absolute;
      left: auto;
      right: -750px;
      top: -170px;
      z-index: 1;
      width: 750px;
      //transform: rotate(-15deg);
      img {
        width: 100%;
      }
    }
    @media ${device.laptop}  {
      left: 110%;
      right: auto;
      top: -60px;
      width: 610px;
    }
    @media ${device.laptopL}  {
      width: 760px;
      top: -140px;
    }
    
    
    .gatsby-image-wrapper{
      overflow: initial;
    }
  }
  
  .lfm-btn-round {
    border: 0;
    border-radius: 32px;
    display: inline;
    text-transform: uppercase;
    margin: 20px 0;
    transition: all .3s;
    font-weight: bold;
    padding: 16px 10px;
    font-size: 16px;
  
    &:focus {
      outline: none;
    }
  }

  .shadow3_alt {
    box-shadow: 0 30px 30px rgba(0, 0, 0, 0.13);
  }
  button {
    cursor: pointer;
    &.shadow3_alt {
      transition: .3s;
  
      &:hover {
        box-shadow: 0 3px 4px rgba(161, 161, 161, 0.4);
      }
    }
  }
`
export default SelfPacedV4
